import React, { useState, useEffect } from 'react';
import moment from 'moment';

//Components
import NovoDestino from './NovoDestino';
import MainCard from '../../../components/MainCard/MainCard';
import FichaDestinoContainer from './components/FichaDestinoContainer';
import Loading from '../../../components/Loading/Loading';

//Api
import destino_api from '../../../api/destino_api';

//Helpers
import { showMessage } from '../../../helpers/message';

export default function FichaDestino({ id, btnVoltar, permissao, integracaoCadastros }) {

    //Estado para controle de edição do destino
    const [editar, setEditar] = useState(false);

    //Estado para controle do loading na tela
    const [loading, setLoading] = useState(true);

    //Estado para guardar os dados do destino
    const [destino, setDestino] = useState();

    //Carrega os dados do destino
    useEffect(() => {
        setLoading(true);
        destino_api.GetItem(id).then(response => {
            const _destino = { ...response.data };

            _destino.latitude = _destino.gps ? _destino.gps.split(";").length > 0 ? _destino.gps.split(";")[0] : "" : "";
            _destino.longitude = _destino.gps ? _destino.gps.split(";").length > 0 ? _destino.gps.split(";")[1] : "" : "";

            if (_destino.tbTipoDestino_id) {
                _destino.tbTipoDestino_id = _destino.tbTipoDestino_id.toString();
            }
            _destino.tiposResiduos = _destino.tiposResiduos.map(value => {
                return { label: value.tipoResiduo, value: value.tipoResiduo_id }
            });
            _destino.validadeLicencaOperacao = moment(_destino.validadeLicencaOperacao).format("YYYY-MM-DD");
            _destino.dataAverbacao = moment(_destino.dataAverbacao).format("YYYY-MM-DD");

            if (_destino.status === "" || _destino.status === null) {
                _destino.status = "Ativo";
            }
            setDestino(prevData => { return { ...prevData, ..._destino } });

        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
            .finally(f => setLoading(false));
    }, []);

    //Se o editar estiver ativo chama a tela de edição
    if (editar) {
        return <NovoDestino destinoParam={destino} setDestino={setDestino} btnVoltar={btnVoltar} />
    }

    //Se o loading estiver ativo chama o loading na tela
    if (loading) {
        return <Loading />
    }
    return (
        <>
            <MainCard btnVoltar={btnVoltar} btnEditar={permissao === "Editar" && !integracaoCadastros ? () => setEditar(true) : null}>
                <FichaDestinoContainer destino={destino} />
            </MainCard>
        </>
    );
}